import { Component } from 'react';
import { registrarErro } from '@/lib/erros';

/**
 * ★★★ WT lote 1 — A RESERVA DA RAIZ.
 *
 * ⚠⚠ Sem isto, erro de render dava **tela branca**: o React desmonta a árvore e não sobra
 * nada — nem a mensagem, nem o menu, nem como voltar. ★ E ninguém ficava sabendo
 * (`docs/wt-medicao.md` §9).
 *
 * ★★ É classe porque **só classe tem `componentDidCatch`** — não há equivalente em hook.
 * ⚠ Não é escolha de estilo.
 *
 * ★ O texto manda recarregar com **Ctrl+Shift+R** de propósito: o caso da Jéssica (03/out)
 * mostrou que recarga normal não resolve quando o problema é cache.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { quebrou: false };
  }

  static getDerivedStateFromError() {
    return { quebrou: true };
  }

  componentDidCatch(erro, info) {
    /**
     * ⚠ `info.componentStack` fica FORA do registro: ele nomeia a árvore de componentes e
     * pode conter texto de props. ★ Vai só para o console, que é local.
     */
    registrarErro({
      origem: 'render',
      codigo: erro?.name ?? 'erro-de-render',
      mensagem: erro?.message ?? String(erro ?? ''),
      extra: info?.componentStack,
    });
  }

  render() {
    if (!this.state.quebrou) return this.props.children;
    return (
      <div className="tela-quebrou" role="alert">
        <h1>Algo deu errado nesta tela.</h1>
        <p>
          Recarregue a página (<kbd>Ctrl+Shift+R</kbd>). Se continuar, avise o suporte.
        </p>
      </div>
    );
  }
}
